import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";

export interface FixIncompleteBookingRateItem {
    id: number;
    date: string;
    rate: number;
}

export interface FixIncompleteBookingPayload {
    room_type_id: string;
    rate_plan_id: string;
    room_id: string;
    checkin_date: string;
    checkout_date: string;
    rates: FixIncompleteBookingRateItem[];
}

/**
 * Mutation untuk melengkapi mapping room type / rate plan / room pada booking
 * yang belum lengkap (mis. booking dari Channex yang belum di-mapping).
 *
 * API Endpoint: PUT `/v4/booking/{id}`
 */
export const useFixIncompleteBookingV4 = () => {
    return useMutation({
        mutationFn: async (values: {
            bookingId: string;
            formData: FixIncompleteBookingPayload;
        }) => {
            const response = await privateApi.put(`/v4/booking/${values.bookingId}`, values.formData);
            return response.data;
        },
        onError: (error) => {
            console.error('Failed to fix incomplete booking', error);
            throw error;
        },
    });
};
